import { Hero } from "../sections/Hero";
import { Marquee } from "../components/Marquee";
import { Pillars } from "../sections/Pillars";
import { Why } from "../sections/Why";
import { FirstWorld } from "../sections/FirstWorld";
import { BookScroll } from "../sections/BookScroll";
import { Music } from "../sections/Music";
import { HowItWorks } from "../sections/HowItWorks";
import { Product } from "../sections/Product";
import { Ringbuch } from "../sections/Ringbuch";
import { Universe } from "../sections/Universe";
import { Philosophy } from "../sections/Philosophy";
import { Community } from "../sections/Community";
import { FAQ } from "../sections/FAQ";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Pillars />
      <Why />
      <FirstWorld />
      <BookScroll />
      <Music />
      <HowItWorks />
      <Product />
      <Ringbuch />
      <Universe />
      <Philosophy />
      <Community />
      <FAQ />
    </main>
  );
}
